export const DATA_MODEL_MODULE_NAME = 'DM';
//# sourceMappingURL=consts.js.map